import { apiClient } from "@lib/axios";
import type {
  TApiKey,
  TApiKeyCreateResponse,
  TApiKeyStatus,
  TApiUsage,
  TAutomationLog,
  TAutomationQueryParams,
  TAutomationStats,
} from "./types";

export interface ICreateApiKeyParams {
  name: string;
  scope: string;
  status?: TApiKeyStatus;
}

export interface IUpdateApiKeyParams {
  id: string;
  name?: string;
  scope?: string;
  status?: TApiKeyStatus;
}

export interface IUpdateApiKeyStatusParams {
  id: string;
  status: TApiKeyStatus;
}

export const apiKeysApi = {
  getApiKeys: () => {
    return apiClient.get<TApiKey[]>("/api-keys");
  },

  getApiUsage: () => {
    return apiClient.get<TApiUsage>("/api-keys/usage");
  },

  createApiKey: (data: ICreateApiKeyParams) => {
    return apiClient.post<TApiKeyCreateResponse>("/api-keys", data);
  },

  updateApiKey: (data: IUpdateApiKeyParams) => {
    const { id, ...updateData } = data;
    return apiClient.put<TApiKey>(`/api-keys/${id}`, updateData);
  },

  deleteApiKey: (id: string) => {
    return apiClient.delete<TApiKey>(`/api-keys/${id}`);
  },

  regenerateApiKey: (id: string) => {
    return apiClient.post<{ token: string }>(`/api-keys/${id}/regenerate`);
  },

  revokeApiKey: (id: string) => {
    return apiClient.post<TApiKey>(`/api-keys/${id}/revoke`);
  },

  queryAutomation: <T extends string | string[]>(
    params: TAutomationQueryParams & { query: T },
  ) => {
    const queryParams = {
      ...params,
      query: Array.isArray(params.query)
        ? params.query.join(",")
        : params.query,
    };

    return apiClient.get<
      T extends string
        ? TAutomationLog[] | TAutomationStats
        : Record<string, TAutomationLog[] | TAutomationStats>
    >("/api-keys/automation", {
      params: queryParams,
    });
  },
};
